import { useContext } from 'react';
import AuthContext from '../context/AuthContext';

export const useAnalytics = () => {
  const { analytics } = useContext(AuthContext);
  return analytics;
};
